import { render, staticRenderFns } from "./ShippingCostTemplate.vue?vue&type=template&id=1098bdf0&scoped=true&"
import script from "./ShippingCostTemplate.vue?vue&type=script&lang=js&"
export * from "./ShippingCostTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1098bdf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1098bdf0')) {
      api.createRecord('1098bdf0', component.options)
    } else {
      api.reload('1098bdf0', component.options)
    }
    module.hot.accept("./ShippingCostTemplate.vue?vue&type=template&id=1098bdf0&scoped=true&", function () {
      api.rerender('1098bdf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/ShippingCostTemplate.vue"
export default component.exports